import React from "react";

import { Table } from "react-bootstrap";

const OverViewTable = (props) => {
  const {
    settings,
    taxValue,
    vatValue,
    currency,
    totalRent,
    collectInstallmentTax,
    collectInstallmentVat,
    collectCommission,
    commisionAmt,
    collectCommissionTax,
    collectCommissionVat,
    contractRenewalFeeData,
    getTotal,
  } = props;

  return (
    <div className="deposit-list">
      <h3 className="table-section-heading font_m fw_6">Overview</h3>
      <div className="custom-table-wrapper">
        <Table className="custom-table font_s" borderless responsive>
          {/* Table Heading */}
          <thead>
            <tr>
              <th className="">
                <p className="font_s fw_6 font_grey">Type</p>
              </th>
              <th className="">
                <p className="font_s fw_6 font_grey">Amount ({currency})</p>
              </th>
              {/* <th> <p className="font_s fw_6 font_grey">Due Date</p> </th> */}
            </tr>
          </thead>
          {/* Table Body */}
          <tbody>
            <tr className="install">
              <td>
                <p className="font_s fw_5">Total Rent</p>
                {(collectInstallmentTax || collectInstallmentVat) && (
                  <>
                    {collectInstallmentTax && (
                      <p className="font_xxs fw_5">Tax({taxValue}%)</p>
                    )}
                    {collectInstallmentVat && (
                      <p className="font_xxs fw_5">VAT({vatValue}%)</p>
                    )}
                    <p className="font_xxs fw_5">Total ({currency})</p>
                  </>
                )}
              </td>

              <td className="amount-column-wrapper">
                <p className="font_s fw_5">
                  {totalRent.toLocaleString("en-US")}
                </p>
                {(collectInstallmentTax || collectInstallmentVat) && (
                  <>
                    {collectInstallmentTax && (
                      <p className="font_xxs fw_5">
                        {((totalRent * taxValue) / 100)?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                      </p>
                    )}
                    {collectInstallmentVat && (
                      <p className="font_xxs fw_5">
                        {((totalRent * vatValue) / 100)?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                      </p>
                    )}
                    <p className="font_xxs fw_5">
                      {getTotal(
                        totalRent,
                        collectInstallmentVat,
                        collectInstallmentTax
                      )}
                    </p>
                  </>
                )}
              </td>
            </tr>

            {contractRenewalFeeData && (
              <tr className="install">
                {/* Name */}
                <td>
                  {(settings?.collect_tax_enabled &&
                    contractRenewalFeeData?.tax_amount &&
                    contractRenewalFeeData?.tax_amount !== 0) ||
                  (settings?.collect_vat_enabled &&
                    contractRenewalFeeData?.vat_amount &&
                    contractRenewalFeeData?.vat_amount !== 0) ? (
                    <p className="font_s fw_5 margin-bottom-0">Renewal Fee</p>
                  ) : (
                    <p className="font_s fw_5">Renewal Fee</p>
                  )}
                  {(settings?.collect_tax_enabled ||
                    settings?.collect_vat_enabled) && (
                    <>
                      {contractRenewalFeeData?.tax_amount !== 0 && (
                        <p className="font_xxs fw_5 margin-bottom-0">
                          Tax({taxValue}%)
                        </p>
                      )}
                      {contractRenewalFeeData?.vat_amount !== 0 && (
                        <p className="font_xxs fw_5 margin-bottom-0">
                          VAT({vatValue}%)
                        </p>
                      )}
                      {contractRenewalFeeData?.tax_amount !== 0 ||
                      contractRenewalFeeData?.vat_amount !== 0 ? (
                        <p className="font_xxs fw_5">Total ({currency})</p>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </td>
                {/* Amount */}
                <td className="amount-column-wrapper">
                  {(settings?.collect_tax_enabled &&
                    contractRenewalFeeData?.tax_amount &&
                    contractRenewalFeeData?.tax_amount !== 0) ||
                  (settings?.collect_vat_enabled &&
                    contractRenewalFeeData?.vat_amount &&
                    contractRenewalFeeData?.vat_amount !== 0) ? (
                    <p className="font_s fw_5 margin-bottom-0">
                      {contractRenewalFeeData?.contract_renewal_amount?.toLocaleString(
                        "en-US"
                      )}
                    </p>
                  ) : (
                    <p className="font_s fw_5">
                      {contractRenewalFeeData?.contract_renewal_amount?.toLocaleString(
                        "en-US"
                      )}
                    </p>
                  )}
                  {(settings?.collect_vat_enabled ||
                    settings?.collect_tax_enabled) && (
                    <>
                      {contractRenewalFeeData?.tax_amount !== 0 && (
                        <p className="font_xxs fw_5 margin-bottom-0">
                          {contractRenewalFeeData?.tax_amount}
                        </p>
                      )}
                      {contractRenewalFeeData?.vat_amount !== 0 && (
                        <p className="font_xxs fw_5 margin-bottom-0">
                          {contractRenewalFeeData?.vat_amount}
                        </p>
                      )}
                      {contractRenewalFeeData?.tax_amount !== 0 ||
                      contractRenewalFeeData?.vat_amount !== 0 ? (
                        <p className="font_xxs fw_5">
                          {contractRenewalFeeData?.total_contract_renewal_amount?.toLocaleString(
                            "en-US"
                          )}
                        </p>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </td>
                {/* <td> {moment(installmentPlan?.updatedAt).format(DATE_FORMAT)} </td> */}
              </tr>
            )}

            {collectCommission && (
              <tr className="install">
                {/* Name */}
                <td>
                  <p className="font_s fw_5">Commission</p>
                  {(collectCommissionTax || collectCommissionVat) && (
                    <>
                      {collectCommissionTax && (
                        <p className="font_xxs fw_5">Tax({taxValue}%)</p>
                      )}
                      {collectCommissionVat && (
                        <p className="font_xxs fw_5">VAT({vatValue}%)</p>
                      )}
                      <p className="font_xxs fw_5">Total ({currency})</p>
                    </>
                  )}
                </td>
                {/* Amount */}
                <td className="amount-column-wrapper">
                  <p className="font_s fw_5">
                    {commisionAmt.toLocaleString("en-US")}
                  </p>
                  {(collectCommissionTax || collectCommissionVat) && (
                    <>
                      {collectCommissionTax && (
                        <p className="font_xxs fw_5">
                          {((commisionAmt * taxValue) / 100)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </p>
                      )}
                      {collectCommissionVat && (
                        <p className="font_xxs fw_5">
                          {((commisionAmt * vatValue) / 100)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </p>
                      )}
                      <p className="font_xxs fw_5">
                        {getTotal(
                          commisionAmt,
                          collectCommissionVat,
                          collectCommissionTax
                        )}
                      </p>
                    </>
                  )}
                </td>
                {/* <td> {moment(installmentPlan?.updatedAt).format(DATE_FORMAT)} </td> */}
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default OverViewTable;
